import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column align-items-center justify-content-center h-100 text-center px-3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "font-size-md mb-2" }, "Provide your location to view Map.", -1 /* HOISTED */)
const _hoisted_3 = {
  key: 1,
  class: "h-100",
  id: "Employee__VisitMap"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex w-100 justify-content-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }),
  /*#__PURE__*/_createElementVNode("b", { class: "mx-2" }, "Waiting for your location"),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" })
], -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.zipNotEntered)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("button", {
          class: "btn btn-xs btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.enterLocation()))
        }, "ENTER LOCATION")
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
}